<template>

    <FlashNotifications ref="flash" />
    <div :class="{ 'hidden': modalHidden }" class="">
        <div @click="toggleModal" class="bg-white/10 flex items-center fixed inset-0 top-0 bottom-0 h-screen right-0 left-0  z-50">
          <div @click.stop="handleModalDetailsClick" 
               class="md:p-2 w-full md:z-50 md:max-w-[490px] md:mr-auto h-screen md:h-full md:max-h-[85vh]"
               :style="modalStyle"
          >
            <div class="relative z-[9999] bg-white dark:bg-[#1C2128] h-screen md:h-fit md:rounded overflow-hidden dark:text-gray-400" style="box-shadow: 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12), 0 11px 15px -7px rgba(0,0,0,.2)">
              <div class="flex items-center justify-end p-2 rounded-t">
<!--                <button-->
<!--                  type="button"-->
<!--                  class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"-->
<!--                  data-tooltip-target="tooltip-edit-booking" data-tooltip-placement="bottom"-->
<!--                >-->
<!--                    <svg class="fill-gray-500 w-5 h-5" viewBox="0 0 24 24"><path d="M20.41 4.94l-1.35-1.35c-.78-.78-2.05-.78-2.83 0L3 16.82V21h4.18L20.41 7.77c.79-.78.79-2.05 0-2.83zm-14 14.12L5 19v-1.36l9.82-9.82 1.41 1.41-9.82 9.83z"></path></svg>            -->
<!--                </button>-->
<!--                <button-->
<!--                  type="button"-->
<!--                  class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"-->
<!--                  data-tooltip-target="tooltip-remove-from-calendar" data-tooltip-placement="bottom"-->
<!--                >-->
<!--                  <svg class="w-5 h-5 fill-gray-500" viewBox="0 0 24 24"><path d="M15 4V3H9v1H4v2h1v13c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V6h1V4h-5zm2 15H7V6h10v13z"></path><path d="M9 8h2v9H9zm4 0h2v9h-2z"></path></svg>-->
<!--                </button>-->
<!--                <button-->
<!--                  type="button"-->
<!--                  class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"-->
<!--                  data-tooltip-target="tooltip-options" data-tooltip-placement="bottom"-->
<!--                >-->
<!--                  <svg class="fill-gray-500 w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"></path></svg>-->
<!--                </button>-->
                
                <button
                  type="button"
                  class="text-gray-500 dark:text-gray-400 bg-transparent hover:bg-gray-50 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-tooltip-target="tooltip-close" data-tooltip-placement="bottom"
                  @click="toggleModal"
                >
                  <svg
                    class="w-3 h-3 fill-gray-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 14 14"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                    ></path>
                  </svg>
                </button>
                <div id="tooltip-edit-booking" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                  {{ I18N.features.bookings.edit_booking }}
                </div>
                <div id="tooltip-remove-from-calendar" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                  {{ I18N.features.bookings.remove_from_calendar }}
                </div>
                <div id="tooltip-options" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                  {{ I18N.features.bookings.options }}
                </div>
                <div id="tooltip-close" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                  {{ I18N.features.bookings.close }}
                </div>
              </div>
              <div class="h-[84vh] md:h-fit md:max-h-[70vh] mt-2 overflow-y-auto scrollbar-style">
                  <div class="pb-4 pl-7 pr-2">
                    <div class="flex">
                        <div class="flex flex-shrink-0 w-10">
                            <div class="w-[14px] h-[14px] mt-2 rounded bg-blue-500" :class="event.color" :style="{ backgroundColor: event.backgroundColor }"></div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="text-lg text-gray-700 dark:text-gray-400">
                              {{ event.title }}
                            </div>
                            <div>
                                <p v-if="event.start_at_variants" class="text-sm text-gray-500 dark:text-gray-400"> {{ event.start_at_variants.details_modal_date_and_time }}</p>
                                <p v-else class="text-sm text-gray-500 dark:text-gray-400"> {{ event.formattedStart }} - {{ event.formattedEnd }}</p>
                            </div>
                        </div>
                    </div>
                    <div v-if="event.google_meet_link !== null && event.google_meet_link !== undefined && event.google_meet_link !== ''" class="flex mt-7">
                        <div class="flex flex-shrink-0 w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M24 4.904v14.355c-.045.04-.032.098-.051.146-.186.485-.832.735-1.31.335-1.043-.874-2.092-1.744-3.139-2.615l-.438-.364v3.606c0 .237-.045.468-.147.682-.285.598-.759.92-1.412.975-.035 0-.07-.003-.102-.003H5.722c-.035 0-.07-.004-.102-.004V16.427c0-.036 0-.072-.003-.104l.013-.013.048.003c2.605 0 5.21 0 7.815.003.077 0 .083-.026.083-.094-.003-1.369 0-2.733 0-4.1 0-.036.003-.072.003-.105.013.008.032.01.042.02.262.224.522.451.781.68l.714.622c.278.244.56.481.838.725.195.17.39.341.59.51.236.205.473.406.71.614.24.208.476.416.713.624.247.215.493.429.74.64.108.094.22.188.345.295V7.41c.007-.01.01-.02.016-.03l.051-.04a2268.9 2268.9 0 003.515-2.926.78.78 0 01.684-.188.8.8 0 01.596.448c.038.069.057.15.086.23z" fill="#00ab47"/><path d="M5.63 16.31l-.013.013c-.023 0-.042-.004-.064-.004H0v-8.64l.006-.005.007.003c.029 0 .057.004.086.004h5.438c.025 0 .054 0 .08-.003.003.003.006.01.01.013v8.56c0 .023 0 .04.003.059z" fill="#2683fb"/><path d="M0 16.319h5.553c.022 0 .041.003.064.003 0 .036.003.072.003.104v5.59c-.035 0-.07.004-.102.004H1.754c-.067 0-.135 0-.199.004a1.417 1.417 0 01-.432-.085C.56 21.73.198 21.334.045 20.744c-.016-.063-.013-.128-.042-.186C0 19.145 0 17.732 0 16.319z" fill="#0066d9"/><path d="M1.552 22.037v-.013c.067 0 .135-.004.199-.004h3.763c.036 0 .07-.004.103-.004.035 0 .07.003.102.003h11.679c.035 0 .07.004.102.004v.013z" fill="#bee9d0"/><path d="M5.617 1.98v-.016h11.89v.013l-.103.002z" fill="#feedbe"/><path d="M5.617 1.98H17.4c.035 0 .07-.003.102-.003.74.052 1.325.54 1.507 1.25.036.134.052.27.052.407v3.635c0 .035.003.07.006.103l-.016.03a.649.649 0 00-.058.041L14.4 11.31c-.272.23-.548.459-.82.686 0-.04-.003-.074-.003-.113V7.798c0-.11 0-.11-.106-.11H5.713a.773.773 0 00-.087.006c-.003-.003-.006-.01-.01-.013 0-.026.004-.055.004-.08V2.07l-.003-.08c-.004-.003 0-.007 0-.01z" fill="#feb900"/><path d="M13.58 12.014c0-.002-.004-.006-.004-.012 0-.004 0-.004.003-.008.272-.226.548-.453.82-.684 1.533-1.29 3.066-2.577 4.596-3.867a.649.649 0 01.057-.041v9.338c-.125-.106-.237-.197-.345-.294l-.74-.64c-.237-.209-.473-.417-.713-.625l-.71-.614c-.196-.169-.391-.34-.59-.51-.278-.24-.56-.48-.838-.724-.24-.208-.477-.416-.714-.624-.26-.227-.522-.45-.78-.679-.01-.006-.027-.01-.043-.016z" fill="#00832d"/><path d="M5.614 1.99l.003.082v5.53l-.003.08-.08.003H.097c-.03 0-.058-.003-.087-.003l.051-.062a5751.59 5751.59 0 005.495-5.574c.02-.02.039-.036.058-.056z" fill="#e84235"/></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="flex justify-between items-center ">
                                <a class="bg-blue-600 rounded px-4 py-2 text-sm text-white focus:outline-none focus-visible:outline-2 hover:text-slate-100 hover:bg-blue-500 inline-flex items-center justify-center"
                                     target="_blank"
                                     :href="event.google_meet_link">
                                    <span> {{ I18N.features.bookings.join_with_google_meet }} </span>
                                </a>
                                <button
                                  type="button"
                                  class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                  @click="copyText(event.google_meet_link)"
                                  data-tooltip-target="tooltip-copy-info" data-tooltip-placement="bottom"
                                >
                                    <svg class="fill-gray-500 dark:fill-gray-400 w-6 h-6"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"></path></svg>
                                </button>
                                <div id="tooltip-copy-info" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                  {{ I18N.features.bookings.copy_conference_info }}
                                </div>
                            </div>
                            <div>
                                <a :href="event.google_meet_link" target="_blank" class="text-xs text-gray-500 dark:text-gray-400 hover:underline">{{ event.google_meet_link }}</a>
                            </div>
                            
                        </div>
                    </div>
                    <div v-if="event.team_meeting_link !== null && event.team_meeting_link !== undefined && event.team_meeting_link !== ''" class="flex mt-4">
                        <div class="flex flex-shrink-0 w-10">
                            <div class="mt-2.5">
                                <svg  class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 278050 333334" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd"><path fill="#ea3e23" d="M278050 305556l-29-16V28627L178807 0 448 66971l-448 87 22 200227 60865-23821V80555l117920-28193-17 239519L122 267285l178668 65976v73l99231-27462v-316z"/></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="flex justify-between items-center ">
                                <a class="bg-blue-600 rounded px-4 py-2 text-sm text-white focus:outline-none focus-visible:outline-2 hover:text-slate-100 hover:bg-blue-500 inline-flex items-center justify-center"
                                     target="_blank"
                                     :href="event.team_meeting_link">
                                    <span> {{ I18N.features.bookings.join_with_teams }} </span>
                                </a>
                                <button
                                  type="button"
                                  class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                  @click="copyText(event.team_meeting_link)"
                                  data-tooltip-target="tooltip-copy-info" data-tooltip-placement="bottom"
                                >
                                    <svg class="fill-gray-500 dark:fill-gray-400 w-6 h-6"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"></path></svg>
                                </button>
                                <div id="tooltip-copy-info" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                  {{ I18N.features.bookings.copy_conference_info }}
                                </div>
                            </div>                            
                        </div>
                    </div>
                    <div class="flex mt-5 group">
                        <div class="flex flex-shrink-0 w-10">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5 fill-gray-500 dark:fill-gray-400" viewBox="0 0 24 24"><path d="M15 8c0-1.42-.5-2.73-1.33-3.76.42-.14.86-.24 1.33-.24 2.21 0 4 1.79 4 4s-1.79 4-4 4c-.43 0-.84-.09-1.23-.21-.03-.01-.06-.02-.1-.03A5.98 5.98 0 0 0 15 8zm1.66 5.13C18.03 14.06 19 15.32 19 17v3h4v-3c0-2.18-3.58-3.47-6.34-3.87zM9 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m0 9c-2.7 0-5.8 1.29-6 2.01V18h12v-1c-.2-.71-3.3-2-6-2M9 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 9c2.67 0 8 1.34 8 4v3H1v-3c0-2.66 5.33-4 8-4z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            <div class="flex justify-between items-center ">
                                <div class="text-gray-500 dark:text-gray-400">
                                    <p class="text-sm">{{ attendees.length }} {{ I18N.features.bookings.guest }}</p>
                                    <p class="text-xs">
                                        <span v-if="attendees.filter(attendee => attendee.response_status === 'accepted').length > 0">
                                            {{ attendees.filter(attendee => attendee.response_status === 'accepted').length }} {{ I18N.application.events.yess }}
                                            <span v-if="attendees.filter(attendee => attendee.response_status === 'declined').length > 0 || attendees.filter(attendee => attendee.response_status === 'needsAction').length > 0">, </span>
                                        </span>
                                        <span v-if="attendees.filter(attendee => attendee.response_status === 'declined').length > 0">
                                            {{ attendees.filter(attendee => attendee.response_status === 'declined').length }} {{ I18N.features.bookings.noo }}
                                            <span v-if="attendees.filter(attendee => attendee.response_status === 'needsAction').length > 0">, </span>
                                        </span>
                                        <span v-if="attendees.filter(attendee => attendee.response_status === 'needsAction').length > 0">
                                            {{ attendees.filter(attendee => attendee.response_status === 'needsAction').length }} {{ I18N.features.bookings.awaiting }}
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    <button
                                      type="button"
                                      @click="copyAttendeeEmails"
                                      class="hidden group-hover:inline-flex text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10  justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                      data-tooltip-target="tooltip-copy-email-guest" data-tooltip-placement="bottom"
                                    >
                                        <svg class="fill-gray-500 dark:fill-gray-400 w-5 h-5"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 2H10c-1.103 0-2 .897-2 2v4H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2v-4h4c1.103 0 2-.897 2-2V4c0-1.103-.897-2-2-2zM4 20V10h10l.002 10H4zm16-6h-4v-4c0-1.103-.897-2-2-2h-4V4h10v10z"></path></svg>
                                    </button>
                                    <button
                                      type="button"
                                      @click="emailGuests"
                                      class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-10 h-10 inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                      data-tooltip-target="tooltip-email-guest" data-tooltip-placement="bottom"
                                    >
                                        <svg class="fill-gray-500 dark:fill-gray-400 w-5 h-5" viewBox="0 0 24 24"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-.8 2L12 10.8 4.8 6h14.4zM4 18V7.87l8 5.33 8-5.33V18H4z"></path></svg>
                                    </button>
                                    <div id="tooltip-copy-email-guest" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                      {{ I18N.features.bookings.copy_guest_emails }}
                                    </div>
                                    <div id="tooltip-email-guest" role="tooltip" class="absolute z-10 invisible inline-block px-2 py-1 text-xs font-medium text-white transition-opacity duration-300 bg-gray-700 rounded shadow-sm opacity-0 tooltip ">
                                      {{ I18N.features.bookings.email_guests }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="attendees.length > 0" class="flex mt-2">
                        <div class="flex-col flex-grow">
                            <div class="text-gray-700 pl-9 text-sm dark:text-gray-400">
                                <div v-for="(attendee, index) in attendees" :key="index" class="flex items-center py-1">
                                    <div class="flex items-end w-8">
                                        <p :class="attendee.bg_color" class="w-6 h-6 flex justify-center items-center rounded-full text-white text-sm"><span v-if="attendee.email !== null && attendee.email !== undefined && attendee.email !== ''">{{ attendee.email.charAt(0).toUpperCase() }}</span></p>
                                        <svg v-if="attendee.response_status == 'accepted'" class="-ml-2" xmlns="https://www.w3.org/2000/svg" width="14" height="14"><path fill="#CEEAD6" d="M7 0c3.87 0 7 3.13 7 7s-3.13 7-7 7-7-3.13-7-7 3.13-7 7-7z"></path><path fill="none" stroke="#137333" stroke-width="1.5" d="M3.5 6.5L6 9l5-5"></path></svg>
                                        <svg  v-if="attendee.response_status == 'declined'" class="-ml-2" xmlns="https://www.w3.org/2000/svg" width="14" height="14"><path fill="#FAD2CF" d="M7 0c3.87 0 7 3.13 7 7s-3.13 7-7 7-7-3.13-7-7 3.13-7 7-7z"></path><path fill="none" stroke="#B31412" stroke-width="1.5" d="M4 10l6-6M10 10L4 4"></path></svg>                            
                                    </div>
                                    <p class="ml-2">
                                        {{ attendee.email }}
                                        <p v-if="attendee.organizer == true" class="text-xs text-gray-400">{{ I18N.features.bookings.organizer }}</p>
                                    </p>
                                </div>                                          
                            </div>
                        </div>
                    </div>
                    <div v-if="event.body !== null && event.body !== '' && event.body !== undefined" class="flex mt-5">
                        <div class="flex flex-shrink-0 w-10 inline-block">
                            <div class="mt-2.5">
                                <svg class="w-5 h-5 fill-gray-500 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ><path d="M4 11h12v2H4zm0-5h16v2H4zm0 12h7.235v-2H4z"></path></svg>
                            </div>
                        </div>
                        <div class=" pr-7">
                            <div class="">
                                <p id="bookingDescription" v-html="formattedEventBody" class="text-sm break-all text-gray-600 dark:text-gray-400"></p>
                            </div>
                        </div>
                    </div>
                    <div v-if="reminders != null || reminders != undefined">
                        <div v-if="reminders.use_default || reminders.overrides !== undefined && reminders.overrides !== null"  class="flex items-center my-3">
                            <div class="w-10 flex-shrink-0">
                                <svg class="w-5 h-5 fill-gray-500 dark:fill-gray-400" viewBox="0 0 24 24"><path d="M18 17v-6c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v6H4v2h16v-2h-2zm-2 0H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6zm-4 5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z"></path></svg>
                            </div>
                            <div class="flex-col flex-grow">
                                
                                <div>
                                    <div class="text-sm text-gray-600 dark:text-gray-400">
                                        <p v-if="reminders.use_default" >{{ I18N.features.bookings.minutes_before }}</p>
                                        <p v-if="!reminders.use_default && reminders.overrides !== undefined && reminders.overrides !== null" 
                                              v-for="reminder in reminders.overrides" :key="reminder"
                                        >
                                              {{ getFormattedTime(reminder.minutes) }}
                                        </p>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div v-if="attendees.filter(attendee => attendee.organizer).length > 0" class="flex items-center mt-3">
                        <div class="flex flex-shrink-0 w-10">
                            <div class="">
                                <svg class="w-5 h-5 fill-gray-500 dark:fill-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11 12h6v6h-6z"></path><path d="M19 4h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm.001 16H5V8h14l.001 12z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-col flex-grow">
                            
                            <div>
                                <p class="text-sm text-gray-600 dark:text-gray-400">
                                    {{ attendees.filter(attendee => attendee.organizer).map(organizer => organizer.email).join(', ') }}
                                    <span class="text-xs text-gray-400 ml-1">({{ I18N.features.bookings.organizer }})</span>
                                </p>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
              <div v-if="attendees.filter(attendee => attendee.self).length > 0" :class="{ '-mt-[43px]' : showNotesSection || event.internal_notes !== null && event.internal_notes !== undefined && event.internal_notes !== '' }" class="bottom-0 fixed w-full md:relative bg-white dark:bg-[#1C2128]">
                  <div class="text-sm  px-3 border-t border-gray-200 dark:border-gray-500 flex items-center justify-between">
                    <div class="py-2">
                        <p class="text-gray-700 dark:text-gray-400">{{ I18N.features.bookings.going }}?</p>
                    </div>  
                    <div class="flex py-2">
                        <div :class="{ 'border-r' : event.internal_notes == null || event.internal_notes == undefined || event.internal_notes == ''}" class="px-1.5 border-gray-200 dark:border-gray-500 gap-x-2 flex items-center">
                            <button @click="updateResponse('accepted')" :disabled="rsvpLoading" :class="{ 'font-semibold text-blue-600 border border-blue-100 bg-blue-100': attendees.some(attendee => attendee.self && attendee.response_status === 'accepted') , 'border border-gray-300 text-gray-700 hover:bg-gray-50 dark:text-gray-400 dark:border-gray-500 dark:hover:bg-gray-700': !attendees.some(attendee => attendee.self && attendee.response_status === 'accepted'), 'opacity-60 cursor-not-allowed': rsvpLoading }" class="px-3 py-1 text-xs rounded-full">{{ I18N.application.events.yess }}</button>
                            <button @click="updateResponse('declined')" :disabled="rsvpLoading" :class="{ 'font-semibold text-blue-600 border border-blue-100 bg-blue-100': attendees.some(attendee => attendee.self && attendee.response_status === 'declined') , 'border border-gray-300 text-gray-700 hover:bg-gray-50 dark:text-gray-400 dark:border-gray-500 dark:hover:bg-gray-700': !attendees.some(attendee => attendee.self && attendee.response_status === 'declined'), 'opacity-60 cursor-not-allowed': rsvpLoading }" class="px-3 py-1 text-xs rounded-full">{{ I18N.features.bookings.noo }}</button>
                            <button @click="updateResponse('needsAction')" :disabled="rsvpLoading" :class="{ 'font-semibold text-blue-600 border border-blue-100 bg-blue-100': attendees.some(attendee => attendee.self && attendee.response_status === 'needsAction') , 'border border-gray-300 text-gray-700 hover:bg-gray-50 dark:text-gray-400 dark:border-gray-500 dark:hover:bg-gray-700': !attendees.some(attendee => attendee.self && attendee.response_status === 'mayBe'), 'opacity-60 cursor-not-allowed': rsvpLoading }" class="px-3 py-1 text-xs rounded-full">{{ I18N.features.bookings.maybe }}</button>
                            
                        </div>
                        <div v-show="event.internal_notes == null || event.internal_notes == undefined || event.internal_notes == ''" class=" pl-1.5">
                             <button @click="toggleNotesSection" class="text-gray-400 bg-transparent hover:bg-gray-50 hover:text-gray-900 rounded-full text-sm w-8 h-8 inline-flex justify-center items-center dark:hover:bg-gray-700 dark:hover:text-white">
                                <svg  class="fill-gray-500 w-5 h-5 dark:fill-gray-400" viewBox="0 0 24 24"><path d="M12 16.41l-6.71-6.7 1.42-1.42 5.29 5.3 5.29-5.3 1.42 1.42z"></path></svg>
                             </button>
                        </div>
                    </div>  
                  </div>
                  <div v-show="showNotesSection || event.internal_notes !== null && event.internal_notes !== undefined && event.internal_notes !== ''" class="text-sm px-3 border-t border-gray-200 dark:border-gray-500 flex items-center justify-end">
                    <div class="flex py-2 max-w-full">
                        <div class="px-1.5 border-gray-200 dark:border-gray-500 flex items-center max-w-full">
                            <button @click="toggleNotesModal" class="border max-w-full border-gray-300 dark:border-gray-500 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700 dark:text-gray-400 px-1.5 py-1 text-xs rounded-full">
                                <div v-if="event.internal_notes == null || event.internal_notes == '' || event.internal_notes == undefined">{{ I18N.features.bookings.add_note }}</div>
                                <div v-else class="max-w-full flex items-center">
                                     <p class="truncate max-w-full px-2">{{ I18N.features.bookings.edit_note }}: {{ event.internal_notes }}</p>
                                     <svg @click.stop
                                        @click="deleteNote"
                                        class="w-2.5 h-2.5 flex-shrink-0 fill-gray-500 dark:fill-gray-400"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 14 14"
                                     >
                                        <path
                                          stroke="currentColor"
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                                        ></path>
                                     </svg>
                                </div>
                            </button>                          
                        </div>
                    </div>  
                  </div>
              </div>
              <div v-else class="h-8 w-full">
              </div>
            </div>
          </div>
        </div>
    </div>
    <div v-show="showNotesModal" tabindex="-1" class="fixed top-0 left-0 right-0 z-[2000] w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full justify-center items-center flex">
        <div class="relative w-full h-full max-w-md md:h-auto">
          <div class="relative bg-white dark:bg-[#1C2128] border border-gray-200 rounded dark:bg-[#22272E] dark:border-gray-500">
            <div class="px-6 py-4">
              <h3 class="mb-3 text-gray-900 dark:text-gray-400">{{ I18N.features.bookings.add_a_note }}</h3>
              <form @submit.prevent="submitNotes">
                <div class="mb-6">
                    <TimelydoTextArea :value="event.internal_notes" 
                                       @focusout="updateNotes" 
                                       rows="5" :placeholder="I18N.features.bookings.add_a_note" 
                                       name="event[notes]" 
                                       :opts="{id: 'booking_notes'}">
                    </TimelydoTextArea>
                </div>
                <div class="space-x-4 flex justify-end w-full items-center rounded-b dark:border-gray-500">
                  <button @click="toggleNotesModal" type="button" class="text-gray-600 text-sm font-medium hover:text-gray-900 dark:text-gray-400">{{ I18N.application.bookings.upcoming.cancel }}</button>
                  <button type="submit" class="text-blue-600 text-sm font-medium hover:text-blue-800">
                    {{ I18N.website_content.account_settings.personal.save }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
    </div>
    
    <div v-show="showNotesModal" class="bg-gray-900 bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-[1000]"></div>
   
  
</template>

<script>
import FlashNotifications from "controllers/vue_components/flash_toast";
import Formatting from "controllers/vue_components/mixins/formatting";
import Constants from "controllers/vue_components/mixins/constants";
import TimelydoTextArea from "controllers/vue_components/fields/timelydo_textarea"
import RequestMixin from "controllers/vue_components/mixins/request"


export default {
    name: 'EventDetailsPopup',
    props: ['host'],
    mixins: [Formatting, Constants, RequestMixin],
    components: {
        FlashNotifications, TimelydoTextArea
    },
    data() {
        return {
            data : {},
            event : {
                body: null
            },
            modalHidden: true,
            parsed_host: {},
            attendees:[],
            xAxis: 0,
            yAxis: 0,
            reminders: {},
            showNotesModal: false,
            showNotesSection: false,
            rsvpLoading: false
        };
    },
    methods: {
        toggleNotesModal() {
            this.showNotesModal = !this.showNotesModal
        },
        toggleNotesSection() {
            this.showNotesSection = !this.showNotesSection
        },
        async updateNotes (e) {
            let fieldValue = ''
            fieldValue = e.target.value
            this.event.internal_notes = fieldValue
        },
        async submitNotes() {
            let end_point = '/api/v1/bookings/'
            let data = {booking: {internal_notes: this.event.internal_notes}}
            if(this.event.category == 'external_booking') {
                end_point = '/api/v1/connected_calendar_bookings_internal_notes/'
                data = {connected_calendar_booking_internal_notes: {internal_notes: this.event.internal_notes}}
            }

            end_point = end_point + `${this.event.id}`

            let response = await this.axiosRequest('PUT', end_point, data, false)
            if (response.js_error == false && response.response.success) {
                this.$refs.flash.show(response.response.message , 'notice');
                console.log(response.response)
                this.toggleNotesModal();
            } else {
                this.$refs.flash.show(response.error.data.message , 'alert');
            }

        },
        async deleteNote() {
            let end_point = ''
            let data = {}
            let response = null

            if (this.event.category == 'timelydo_booking' ){
                end_point = `/api/v1/bookings/${this.event.id}`
                data = {booking: {internal_notes: null}}
                response = await this.axiosRequest('PUT', end_point, data, false)
            }

            if(this.event.category == 'external_booking') {
                end_point = `/api/v1/connected_calendar_bookings_internal_notes/${this.event.id}`
                data = {connected_calendar_booking_internal_notes: {internal_notes: this.event.internal_notes}}
                response = await this.axiosRequest('DELETE', end_point, data, false)
            }

            if (response.js_error == false && response.response.success) {
                this.event.internal_notes = null
                this.$refs.flash.show(response.response.message , 'notice');
                console.log(response.response)
                // this.toggleNotesModal();
            } else {
               console.log(response)
            }

        },
        copyText(text) {
            this.copyTextToClipboard(text);
            this.$refs.flash.show( this.I18N.features.bookings.link_copied , "notice");
        },
        copyAttendeeEmails(){
            const attendeeEmails = this.attendees.map((attendee) => attendee.email).join(', ');
            if (attendeeEmails.length > 0 ){
                this.copyTextToClipboard(attendeeEmails);
                this.$refs.flash.show(this.I18N.features.bookings.emails_copied, 'notice');
            }
            else {
                this.$refs.flash.show(this.I18N.features.bookings.no_attendee_available, 'alert');
            }
        },
        emailGuests() {
            const emailAddresses = this.attendees.map(attendee => attendee.email).join(',');
            if (emailAddresses.length > 0 ){
                window.location.href = `mailto:${emailAddresses}`;
            }
            else {
                this.$refs.flash.show(this.I18N.features.bookings.no_attendee_available, 'alert');
            }
        },
        formatStartDateTime(dateTime) {
            const options = {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: (this.parsed_host.time_format === '12_hours'),
            };

            return new Date(dateTime).toLocaleString('en-US', options);
        },
        formatEndDateTime(dateTime) {
            const endDate = new Date(dateTime);
            const startDate = new Date(this.event.start);

            const options = {
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: (this.parsed_host.time_format === '12_hours'),
            };

            if (endDate.toDateString() === startDate.toDateString()) {
                // Same day, only include time
                options.weekday = undefined;
                options.year = undefined;
                options.month = undefined;
                options.day = undefined;
            } else {
                // Different days, include day and time
                options.weekday = 'long';
                options.year = 'numeric';
                options.month = 'long';
                options.day = 'numeric';
            }

            return endDate.toLocaleString('en-US', options);
        },

        updateEventData(event, data) {
            this.data = data;
            this.event = event;
            this.attendees = event.attendees;
            this.reminders = event.reminders;
            if(data.clientX){
                this.xAxis = data.clientX;
                if(this.xAxis < 550){
                    this.xAxis = this.xAxis + 100
                } else {
                    this.xAxis = this.xAxis - 550
                }
                this.yAxis = data.clientY
            }
            else {
                this.xAxis = data.nativeEvent.clientX;
                if(this.xAxis < 550){
                    this.xAxis = this.xAxis + 100
                } else {
                    this.xAxis = this.xAxis - 550
                }
                this.yAxis = data.nativeEvent.clientY
            }

            const formattedStart = this.formatStartDateTime(this.event.start);
            const formattedEnd = this.formatEndDateTime(this.event.end);

            this.event.formattedStart = formattedStart;
            this.event.formattedEnd = formattedEnd;
            if(event.start_at_variants){
                this.event.body = event.html_description;
            }
        },
        toggleModal(){
            this.modalHidden = !this.modalHidden

            if (!this.modalHidden) {
                this.showNotesSection = false;
            }
        },
        handleModalDetailsClick(event) {
            event.stopPropagation();
        },
        getFormattedTime(minutes) {
            if (minutes > 59) {
                const hours = Math.floor(minutes / 60);
                const remainingMinutes = minutes % 60;
                if (hours > 23) {
                    const days = Math.floor(hours / 24);
                    const remainingHours = hours % 24;

                    let result = "";

                    if (days === 1) {
                        result += "1 day";
                    } else if (days > 1) {
                        result += `${days} days`;
                    }

                    if (remainingHours === 1) {
                        result += result ? ` and 1 hour` : `1 hour`;
                    } else if (remainingHours > 1) {
                        result += result ? ` and ${remainingHours} hours` : `${remainingHours} hours`;
                    }

                    if (remainingMinutes === 1) {
                        result += result ? ` and 1 minute` : `1 minute`;
                    } else if (remainingMinutes > 1) {
                        result += result ? ` and ${remainingMinutes} minutes` : `${remainingMinutes} minutes`;
                    }

                    return result ? result + " before" : "0 minutes before";
                } else {
                    let result = "";
                    if (hours > 0) {
                        result += hours === 1 ? "1 hour" : `${hours} hours`;
                    }

                    if (remainingMinutes > 0) {
                        result += result && hours ? ` and ${remainingMinutes} minutes` : `${remainingMinutes} minutes`;
                    }

                    return result ? result + " before" : "0 minutes before";
                }
            } else {
                return `${minutes} minutes before`;
            }
        },

        sanitizeBody(html) {
            if (!html) return '';
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent || '';
        },

        async updateResponse(status){
            if (this.rsvpLoading) return;
            this.rsvpLoading = true;
            let data = {
                calendar: {
                    id: this.event.id,
                    booking: {
                        id: this.event.id,
                        response_status: status
                    }
                }
            }
            let response = await this.axiosRequest('PUT', '/api/v1/google_calendar_bookings/update_response_status', data, false)
            this.rsvpLoading = false;
            if (response.js_error == false && response.response.success) {
                for (let attendee of this.event.attendees) {
                    if (attendee.self) {
                        attendee.response_status = status;
                        break;
                    }
                }
                this.$refs.flash.show(response.response.message , 'notice');
                this.toggleModal();
            } else {
                this.$refs.flash.show(response.error.data.message , 'alert');
            }
        },
    },

    computed: {
        modalStyle() {
            if(window.innerWidth > 768 ) {
                if ( 450 + this.xAxis < window.innerWidth ){
                    return {
                        marginLeft: this.xAxis + 'px'
                    };
                }
                else {
                    const temp = window.innerWidth - 480
                    return {
                        marginLeft:  temp + 'px'
                    };
                }
            }
        },
        formattedEventBody() {
            const plainText = this.sanitizeBody(this.event.body);
            if (!plainText) return "";
            let formattedBody = plainText.replace(/\n/g, '<br>');
            formattedBody = formattedBody.replace(/(https?:\/\/[^\s<>"']+)/g, (url) => {
                const safeUrl = encodeURI(url);
                return `<a href="${safeUrl}" class="text-blue-600 underline" target="_blank" rel="noopener noreferrer">${safeUrl}</a>`;
            });
            return formattedBody;
        },

    },
    created() {
        if (this.host) {
            this.parsed_host = JSON.parse(this.host);
        }
    }
};
</script>
